module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Black.4e7476a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Black.woff2
// module id = sakq
// module chunks = 0